module.exports = __webpack_public_path__ + "img/icon82.d8e149b9.png";